import React, { Fragment } from 'react';

import ContentEditor from '../../contentEditor';
import ErrorMessage from './errorMessage';

const HHContentEditor = (props) => {
  const {
    field,
    form: { setFieldValue, touched, errors },
    isPreview,
    maxImageSizeMB,
    ...otherProps
  } = props;

  const hasError = !!(touched[field.name] && errors[field.name]);
  const { userToken, fileType, slug } = otherProps;

  return (
    <Fragment>
      { (typeof field.value.length === 'number') && (
        <ContentEditor
          value={field.value}
          isPreview={isPreview}
          onChange={val => setFieldValue(field.name, val)}
          onAddNewBlock={(newBlock) => setFieldValue(field.name, [...field.value, newBlock])}
          onDeleteBlock={i => {
            setFieldValue(field.name, field.value.filter((value, index) => index !== i));
          }}
          maxImageSizeMB={maxImageSizeMB}
          fileType={fileType}
          userToken={userToken}
          slug={slug}
          // {...otherProps}
        />
      ) }
      {hasError && (<ErrorMessage error={errors[field.name]} />)}
    </Fragment>
  );
};

export default HHContentEditor;



// WEBPACK FOOTER //
// ./src/components/forms/fields/hhContentEditor.js